let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("b8zCh")).then(() => parcelRequire('ijUCF'));